/* @begin tools\lib\annotation\resource\Parser {
	"id": {
		"type": "js",
		"name": "aptis.htmlEscaper",
		"precedence": 1
	}
} @end tools\lib\annotation\resource\Parser */
aptis.HtmlEscaper = new Class({

	/**
	 * @var {String}
	 */
	_htmlEscapeMap: {
		"&": "&amp;",
		"<": "&lt;",
		">": "&gt;",
		'"': '&quot;',
		"'": '&#39;',
		"/": '&#x2F;'
	},

	/**
	 * @param {String} text
	 * @return {String}
	 */
	escape: function(text) {
		if (!text) {
			return text;
		}

		var me = this;
		return String(text).replace(/[&<>"'\/]/g, function (s) {
			return me._htmlEscapeMap[s];
		});
	}
});